import { FC } from "react";
import classNames from "classnames";

import { ContentLayoutProps } from "./types";

import styles from "./ContentLayout.module.css";



const ContentLayout: FC<ContentLayoutProps> = ({ children, className }) => {
  return <div className={classNames(styles["container"], className)}>{children}</div>;
}

export default ContentLayout;